// extracted by mini-css-extract-plugin
module.exports = {"cropContainer":"EditImage_cropContainer__3W8b9","imageLoadingWrapper":"EditImage_imageLoadingWrapper__1ZMhY"};